import UserPreferencesGetters from "./UserPreferencesGetters";
import UserPreferencesActions from "./UserPreferencesActions";
import UserPreferencesMutations from "./UserPreferencesMutations";
import UsersService from "@/services/common/UsersService";

const state = UsersService.EmptyUserPreferencesStateFactory();

const { getters } = UserPreferencesGetters;

const { actions } = UserPreferencesActions;

const { mutations } = UserPreferencesMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations,
};
